require('./mortgageRequestCoHolderRNC.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { InputSafe } = require('commonsComponents/inputSafe');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { formatText } = require('core/i18n').i18n;
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');

// @actions
const getHolderActions = require('actions/mortgageRequest/mortgageRequestHolder');

// @constants
const prefixPhoneNumber = '+34';
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const passportRegex = /^(?=(?:[A-Z]*\d){6})(?=(?:\d*[A-Z]){3})\w{9}$/
const { isValidNif,
    isValidNie,
    validateDate,
    validateExpirationDate,
    isValidName,
    REGEXNAME } = require('./formValidations');


class MortgageRequestCoHolderRNC extends React.Component {
    constructor(props) {
        super(props);
        const addDefaultError = formatText('mortgageRequestHolderInformation-defaultFormError');

        this.state = {
            name: '',
            nameValid: false,
            nameErrorMessage: addDefaultError,
            firstLastName: '',
            firstLastNameValid: false,
            firstLastNameErrorMessage: addDefaultError,
            secondLastName: '',
            secondLastNameValid: false,
            secondLastNameErrorMessage: addDefaultError,
            documentType: 'N',
            documentNumber: '',
            documentNumberValid: false,
            documentNumberErrorMessage: addDefaultError,
            documentExpirationDay: '',
            documentExpirationDayValid: false,
            documentExpirationDayErroMessage: addDefaultError,
            documentExpirationMonth: '',
            documentExpirationMonthValid: false,
            documentExpirationMonthErrorMessage: addDefaultError,
            documentExpirationYear: '',
            documentExpirationYearValid: false,
            documentExpirationYearErrorMessage: addDefaultError,
            mobileCountryIndicative: prefixPhoneNumber,
            mobileNumber: '',
            mobileNumberFormatter: '',
            mobileNumberValid: false,
            mobileNumberErrorMessage: addDefaultError,
            email: '',
            emailValid: false,
            emailErrorMessage: addDefaultError,
            authorizedAddCoHolderCheck: false,
            authorizedAddCoHolderCheckValid: false,
            authorizedAddCoHolderCheckErrorMessage: addDefaultError,
            saving: false
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleSelectDocumentType = this.handleSelectDocumentType.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleSaveCoHolder = this.handleSaveCoHolder.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.resetErrorMessages = this.resetErrorMessages.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            saving: nextProps.coHolderEdit.get('isFetching')
        });
    }

    handleChange(evt) {
        const { name, value } = evt.target;
        const numericLetterRegex = /[^0-9]+/g;

        switch (name) {
            case 'documentExpirationDay':
            case 'documentExpirationMonth':
            case 'documentExpirationYear':
                this.setState({ [name]: value.toUpperCase().replace(numericLetterRegex, '') });
                break;
            case 'name':
            case 'firstLastName':
            case 'secondLastName':
                this.setState({ [name]: (REGEXNAME.test(value)) ? value : value.substring(0, value.length - 1) });
                break;
            case 'mobileNumber':
                const number = value.toUpperCase().replace(numericLetterRegex, '')
                this.setState({ [name]: number.trim(), [`${name}Formatter`]: number.trim() })
                break;
            case 'documentNumber':
                this.setState({ [name]: value.toUpperCase() });
                break;
            default:
                this.setState({ [name]: value })

        }
    }

    handleCheckboxChange(event) {
        this.setState({ [event.target.id]: event.target.checked });
    }

    handleSelectDocumentType(value) {
        this.setState({
            documentType: value.value
        });
    }

    handleFocus(event) {
        this.setState({
            mobileNumberFormatter: event.target.value.replace(/ /g, '').trim()
        })
    }

    handleBlur(evt) {
        const { value, name } = evt.target;
        const numericLetterRegex = /[^0-9]+/g;
        if (name === 'mobileNumber') {
            const noLetterinNumber = value.toUpperCase().replace(numericLetterRegex, '');
            const noFormattedNumber = noLetterinNumber.replace(/ /g, '').trim();
            const formattedNumber = `${noFormattedNumber.substring(0, 3)} ${noFormattedNumber.substring(3, 6)} ${noFormattedNumber.substring(6, value.length)}`
            this.setState({
                [`${name}Formatter`]: formattedNumber
            });
        } else {
            this.setState({ [name]: value.trim() });
        }
    }

    handleSaveCoHolder(event) {
        event && event.preventDefault();
        const { handleAddCoHolder, history } = this.props;
        const valid = this.validateForm();
        if (valid) {
            handleAddCoHolder(this.state, history);
        }
    }

    validateForm() {
        const addDefaultError = formatText('mortgageRequestHolderInformation-defaultFormError');
        const defaultErrorFormat = formatText('mortgageRequestCOHolderInformation-defaultErrorFormat');
        const dniError = formatText('mortgageRequestCOHolderInformation-dniError');
        const nieError = formatText('mortgageRequestCOHolderInformation-nieError');
        const incorrectDay = formatText('mortgageRequestCOHolderInformation-incorrectDay');
        const incorrectMonth = formatText('mortgageRequestCOHolderInformation-incorrectMonth');
        const incorrectYear = formatText('mortgageRequestCOHolderInformation-incorrectYear');
        const expirationDayError = formatText('mortgageRequestCOHolderInformation-expirationDayError');
        const mobileNumberIncorrect = formatText('mortgageRequestCOHolderInformation-mobileNumberIncorrect');
        const emailError = formatText('mortgageRequestCOHolderInformation-emailError');
        const acceptAuthorizationError = formatText('mortgageRequestCOHolderInformation-acceptAuthorizationError');

        let valid = true;
        this.resetErrorMessages();
        const phoneRegex6 = /^[6][0-9]{8}/;
        const phoneRegex7 = /^[7][1-4][0-9]{7}/;

        if (this.state.name === '') {
            this.setState({ nameValid: true, nameErrorMessage: addDefaultError });
            valid = false;
        } else if (!isValidName(this.state.name)) {
            this.setState({ nameValid: true, nameErrorMessage: defaultErrorFormat });
            valid = false;
        }

        if (this.state.firstLastName === '') {
            this.setState({ firstLastNameValid: true, firstLastNameErrorMessage: addDefaultError });
            valid = false;
        } else if (!isValidName(this.state.firstLastName)) {
            this.setState({ firstLastNameValid: true, firstLastNameErrorMessage: defaultErrorFormat });
            valid = false;
        }

        if (this.state.documentNumber === '') {
            valid = false;
            this.setState({
                documentNumberValid: true,
                documentNumberErrorMessage: addDefaultError
            });
        }

        if (this.state.documentType === 'N' && this.state.documentNumber !== '') {
            if (!isValidNif(this.state.documentNumber)) {
                valid = false;
                this.setState({
                    documentNumberValid: true,
                    documentNumberErrorMessage: dniError
                });
            }
        }

        if (this.state.documentType === 'N' && this.state.secondLastName === '') {
            this.setState({ secondLastNameValid: true, secondLastNameErrorMessage: addDefaultError });
            valid = false;
        } else if (this.state.secondLastName !== '' && !isValidName(this.state.secondLastName)) {
            this.setState({ secondLastNameValid: true, secondLastNameErrorMessage: defaultErrorFormat });
            valid = false;
        }

        if (this.state.documentType === 'C' && this.state.documentNumber !== '') {
            if (!isValidNie(this.state.documentNumber)) {
                valid = false;
                this.setState({
                    documentNumberValid: true,
                    documentNumberErrorMessage: nieError
                });
            }
        }

        if (this.state.documentType === 'P') {
            if (!passportRegex(this.state.documentNumber)) {
                valid = false;
                this.setState({
                    documentNumberValid: true,
                    documentNumberErrorMessage: nieError
                });
            }
        }

        if (this.state.documentExpirationDay === '') {
            valid = false;
            this.setState({ documentExpirationDayValid: true, documentExpirationDayErroMessage: addDefaultError });
        }
        if (this.state.documentExpirationMonth === '') {
            valid = false;
            this.setState({ documentExpirationMonthValid: true, documentExpirationMonthErrorMessage: addDefaultError });
        }
        if (this.state.documentExpirationYear === '') {
            valid = false;
            this.setState({ documentExpirationYearValid: true, documentExpirationYearErrorMessage: addDefaultError });
        }

        const validateDateObject = validateDate(this.state.documentExpirationDay,
            this.state.documentExpirationMonth,
            this.state.documentExpirationYear);

        if (validateDateObject.dayError) {
            valid = false;
            this.setState({ documentExpirationDayValid: true, documentExpirationDayErroMessage: incorrectDay });
        }

        if (validateDateObject.monthError) {
            valid = false;
            this.setState({ documentExpirationMonthValid: true, documentExpirationMonthErrorMessage: incorrectMonth });
        }

        if (validateDateObject.yearError) {
            valid = false;
            this.setState({ documentExpirationYearValid: true, documentExpirationYearErrorMessage: incorrectYear });
        } else {
            if (!validateExpirationDate(this.state.documentExpirationDay,
                this.state.documentExpirationMonth,
                this.state.documentExpirationYear)) {
                valid = false;
                this.setState({ documentExpirationDayValid: true, documentExpirationDayErroMessage: expirationDayError });
            }
        }

        let phoneErrorCounter = 0;

        if (this.state.mobileNumber === '') {
            valid = false;
            this.setState({ mobileNumberValid: true, mobileNumberErrorMessage: addDefaultError });
        } else if (this.state.mobileNumber.charAt(0) === '6' && !phoneRegex6.test(this.state.mobileNumber)) {
            phoneErrorCounter++;
        } else if (this.state.mobileNumber.charAt(0) === '7' && !phoneRegex7.test(this.state.mobileNumber)) {
            phoneErrorCounter++;
        } else if (this.state.mobileNumber.charAt(0) !== '6' && this.state.mobileNumber.charAt(0) !== '7') {
            phoneErrorCounter++;
        }

        if (phoneErrorCounter > 0) {
            valid = false;
            this.setState({ mobileNumberValid: true, mobileNumberErrorMessage: mobileNumberIncorrect });
        }

        if (this.state.email === '') {
            valid = false;
            this.setState({ emailValid: true, emailErrorMessage: addDefaultError });
        } else if (!emailRegex.test(this.state.email)) {
            valid = false;
            this.setState({ emailValid: true, emailErrorMessage: emailError });
        }

        if (!this.state.authorizedAddCoHolderCheck) {
            valid = false;
            this.setState({
                authorizedAddCoHolderCheckValid: true,
                authorizedAddCoHolderCheckErrorMessage: acceptAuthorizationError
            })
        }

        return valid;
    }

    resetErrorMessages() {
        this.setState({
            nameValid: false,
            firstLastNameValid: false,
            secondLastNameValid: false,
            documentNumberValid: false,
            documentExpirationDayValid: false,
            documentExpirationMonthValid: false,
            documentExpirationYearValid: false,
            mobileNumberValid: false,
            emailValid: false,
            authorizedAddCoHolderCheckValid: false,
        })
    }

    render() {
        const idNumberOptions = [
            {
                label: `${formatText('mortgageRequestHolderInformationIdNumberOptions-DNI')}`,
                value: 'N'
            },
            {
                label: `${formatText('profile-personalDataNIE'
                )}`,
                value: 'C'
            }
        ];

        return (
            <div className="mortgage-request-co-holder-rnc">
                <ContentBox hasShadow={false}>
                    <div className="mortgage-request-co-holder-rnc__form">
                        <div className="row">
                            <div className="col-xs-12 mortgage-request-co-holder-rnc__form__head">
                                <h2 className="mortgage-request-co-holder-rnc__form__head--title">{formatText('mortgageRequestCOHolderInformation-addCoHolderHeaderTitle')}</h2>
                                <p className="mortgage-request-co-holder-rnc__form__head--subtitle">{formatText('mortgageRequestCOHolderInformation-addCoHolderHeadersubTitle')}</p>
                                <span className="mortgage-request-co-holder-rnc__form__head--separator" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 mortgage-request-co-holder-rnc__form__section">
                                <h3 className="mortgage-request-co-holder-rnc__form__section--title">{formatText('mortgageRequestCOHolderInformation-fullnameSection')}</h3>
                            </div>
                            <div className="mortgage-request-co-holder-rnc__form__joining-input">
                                <div className="col-lg-4 col-xs-12 col-md-4 col-sm-4 mortgage-request-co-holder-rnc__form__joining-input__child">

                                    <InputSafe
                                        name="name"
                                        type="text"
                                        value={this.state.name}
                                        placeholder={formatText('mortgageRequestCOHolderInformation-fullnameSectionName')}
                                        onBlur={this.handleBlur}
                                        onChange={this.handleChange}
                                        errorState={this.state.nameValid}
                                        errorMessage={this.state.nameErrorMessage}
                                    />
                                </div>
                                <div className="col-lg-4 col-xs-12 col-md-4 col-sm-4 mortgage-request-co-holder-rnc__form__joining-input__child">

                                    <InputSafe
                                        name="firstLastName"
                                        type="text"
                                        value={this.state.firstLastName}
                                        placeholder={formatText('mortgageRequestCOHolderInformation-fullnameSectionFirstSurname')}
                                        onBlur={this.handleBlur}
                                        onChange={this.handleChange}
                                        errorState={this.state.firstLastNameValid}
                                        errorMessage={this.state.firstLastNameErrorMessage}
                                    />
                                </div>
                                <div className="col-lg-4 col-xs-12 col-md-4 col-sm-4 mortgage-request-co-holder-rnc__form__joining-input__child">

                                    <InputSafe
                                        name="secondLastName"
                                        type="text"
                                        value={this.state.secondLastName}
                                        placeholder={formatText('mortgageRequestCOHolderInformation-fullnameSectionSecondSurname')}
                                        onBlur={this.handleBlur}
                                        onChange={this.handleChange}
                                        errorState={this.state.secondLastNameValid}
                                        errorMessage={this.state.secondLastNameErrorMessage}
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-md-6 col-lg-6 ">
                                <div className="row">
                                    <div className="col-xs-12 mortgage-request-co-holder-rnc__form__section">
                                        <h3 className="mortgage-request-co-holder-rnc__form__section--title">{formatText('mortgageRequestCOHolderInformation-identificationSection')}</h3>
                                    </div>
                                    <div className="mortgage-request-co-holder-rnc__form__joining-input">
                                        <div className="col-xs-12 col-md-4 col-lg-4 col-sm-4 mortgage-request-co-holder-rnc__form__joining-input__child">
                                            <OKSelect
                                                label={''}
                                                name="documentType"
                                                options={idNumberOptions}
                                                value={this.state.documentType}
                                                clearable={false}
                                                searchable={false}
                                                onChange={this.handleSelectDocumentType}
                                            />
                                        </div>
                                        <div className="col-xs-12 col-md-8 col-lg-8 col-sm-8 mortgage-request-co-holder-rnc__form__joining-input__child__identification-number">
                                            <InputSafe
                                                name="documentNumber"
                                                type="text"
                                                value={this.state.documentNumber}
                                                placeholder={formatText('mortgageRequestCOHolderInformation-identificationSectionIDNumber')}
                                                onBlur={this.handleBlur}
                                                onChange={this.handleChange}
                                                errorState={this.state.documentNumberValid}
                                                errorMessage={this.state.documentNumberErrorMessage}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xs-12 col-md-6 col-lg-6">
                                <div className="row">
                                    <div className="col-xs-12 mortgage-request-co-holder-rnc__form__section">
                                        <h3 className="mortgage-request-co-holder-rnc__form__section--title">{formatText('mortgageRequestCOHolderInformation-expirationDateDocumentSection')}</h3>
                                    </div>
                                    <div className="mortgage-request-co-holder-rnc__form__joining-input">
                                        <div className="col-xs-12 col-md-3 col-lg-3 col-sm-3 mortgage-request-co-holder-rnc__form__joining-input__child__date">
                                            <InputSafe
                                                maxLength={2}
                                                name="documentExpirationDay"
                                                type="text"
                                                value={this.state.documentExpirationDay}
                                                placeholder={'00'}
                                                onBlur={this.handleBlur}
                                                onChange={this.handleChange}
                                                errorState={this.state.documentExpirationDayValid}
                                                errorMessage={this.state.documentExpirationDayErroMessage}
                                            />
                                        </div>
                                        <div className="col-xs-12 col-md-3 col-lg-3 col-sm-3 mortgage-request-co-holder-rnc__form__joining-input__child">
                                            <InputSafe
                                                maxLength={2}
                                                name="documentExpirationMonth"
                                                type="text"
                                                value={this.state.documentExpirationMonth}
                                                placeholder={'00'}
                                                onBlur={this.handleBlur}
                                                onChange={this.handleChange}
                                                errorState={this.state.documentExpirationMonthValid}
                                                errorMessage={this.state.documentExpirationMonthErrorMessage}
                                            />
                                        </div>
                                        <div className="col-xs-12 col-md-6 col-lg-6 col-sm-6 mortgage-request-co-holder-rnc__form__joining-input__child">
                                            <InputSafe
                                                maxLength={4}
                                                name="documentExpirationYear"
                                                type="text"
                                                value={this.state.documentExpirationYear}
                                                placeholder={'0000'}
                                                onBlur={this.handleBlur}
                                                onChange={this.handleChange}
                                                errorState={this.state.documentExpirationYearValid}
                                                errorMessage={this.state.documentExpirationYearErrorMessage}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xs-12 col-md-6 col-lg-6">
                                <div className="row">
                                    <div className="col-xs-12 mortgage-request-co-holder-rnc__form__section">
                                        <h3 className="mortgage-request-co-holder-rnc__form__section--title">{formatText('mortgageRequestCOHolderInformation-mobileNumberSection')}</h3>
                                    </div>
                                    <div className="col-xs-12 col-md-3 col-lg-3 col-sm-2">
                                        <InputSafe
                                            name="mobileCountryIndicative"
                                            type="text"
                                            value={this.state.mobileCountryIndicative}
                                            placeholder={prefixPhoneNumber}
                                            onBlur={this.handleBlur}
                                            onChange={this.handleChange}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-xs-12 col-md-9 col-lg-9 col-sm-10">
                                        <InputSafe
                                            maxLength={9}
                                            name="mobileNumber"
                                            type="text"
                                            value={this.state.mobileNumberFormatter}
                                            placeholder={formatText('mortgageRequestCOHolderInformation-mobileNumberSection')}
                                            onBlur={this.handleBlur}
                                            onFocus={this.handleFocus}
                                            onChange={this.handleChange}
                                            errorState={this.state.mobileNumberValid}
                                            errorMessage={this.state.mobileNumberErrorMessage}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-xs-12 col-md-6 col-lg-6">
                                <div className="row">
                                    <div className="col-xs-12 mortgage-request-co-holder-rnc__form__section">
                                        <h3 className="mortgage-request-co-holder-rnc__form__section--title">{formatText('mortgageRequestCOHolderInformation-emailSection')}</h3>
                                    </div>
                                    <div className="col-xs-12">
                                        <InputSafe
                                            name="email"
                                            type="email"
                                            value={this.state.email}
                                            placeholder={formatText('mortgageRequestCOHolderInformation-emailSectionPlaceHolder')}
                                            onBlur={this.handleBlur}
                                            onChange={this.handleChange}
                                            errorState={this.state.emailValid}
                                            errorMessage={this.state.emailErrorMessage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mortgage-request-co-holder-rnc__form__authorized-container">
                            <div className="col-xs-12">
                                <OKCheckbox
                                    idName="authorizedAddCoHolderCheck" authorizedOpenBankCoHolder
                                    extraClass=""
                                    label={formatText('mortgageRequestCOHolderInformation-authorizedOpenBankCoHolder')}
                                    onChange={this.handleCheckboxChange}
                                    value={this.state.authorizedAddCoHolderCheck}
                                    errorState={this.state.authorizedAddCoHolderCheckValid}
                                    errorMessage={this.state.authorizedAddCoHolderCheckErrorMessage}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xs-12">
                                <hr />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xs-6 text-left mortgage-request-co-holder-rnc__form__cancel">
                                <OKLink
                                    to="/myprofile/mortgage/panel"
                                >
                                    {formatText('mortgageRequestCOHolderInformation-cancelFormAction')}
                                </OKLink>
                            </div>
                            <div className="col-xs-6 text-right mortgage-request-co-holder-rnc__form__save">
                                <OKButton
                                    onClick={this.handleSaveCoHolder}
                                    modifier="primary"
                                    loading={this.state.saving}
                                >
                                    {formatText('mortgageRequestCOHolderInformation-addCoHolderAction')}
                                </OKButton>
                            </div>
                        </div>
                    </div>
                </ContentBox>
            </div>
        );
    }
}

MortgageRequestCoHolderRNC.propTypes = {
    mortgageRequestState: PropTypes.object,
    holderInfo: PropTypes.object,
    handleAddCoHolder: PropTypes.func,
    holderId: PropTypes.string,
    coHolderEdit: PropTypes.object,
    history: PropTypes.object.isRequired,
}


module.exports.MortgageRequestCoHolderRNC = withRouter(connect(
    state => ({
        holderInfo: state.mortgageRequestHolder,
        mortgageRequestState: state.mortgageRequestState,
        coHolderEdit: state.mortgageRequestCoHolderEdit
    }),
    {
        handleAddCoHolder: getHolderActions.addCoHolderRNCForm,
    }
)(MortgageRequestCoHolderRNC));
